class OnLoadScrollToEl{
  constructor(scrollToEl) {
    try {
      this.checkUrlValue = scrollToEl.getAttribute("data-scroll-to-check");
      this.scrollToEl =  scrollToEl;
      this.pageUrl = window.location.href;
      
      if(this.checkUrlValue && this.pageUrl.includes(this.checkUrlValue)){
        const userAgent = navigator.userAgent.toLowerCase();
        
        if(/android|iphone|ipod|ipad|blackberry|windows phone/.test(userAgent)){
          this.disableTouchOnMobile() ;
          window.addEventListener('load', () => {
            setTimeout(() => this.scrollToElement(),750);
            setTimeout(() => this.enableTouchOnMobile(),1500);
          });
        }
        else{
          window.addEventListener('load', () => {
            this.scrollToElement();
          });
        }
      }
    }catch (error) {
      console.log(error);
    }
  }

  scrollToElement = () => {
    let headerHeight = document.querySelector(".global__header").clientHeight + 20,
        elementPosition = this.scrollToEl.offsetTop,
        scrollToPosition = elementPosition - headerHeight;
    window.scrollTo({
      top: scrollToPosition,
      behavior: "smooth"
    });
  }

  disableTouch = (event) => {
    event.preventDefault();
  }
  enableTouchOnMobile = () => {
    document.removeEventListener('touchmove', this.disableTouch, { passive: false });
  }
  disableTouchOnMobile = () => {
    document.addEventListener('touchmove', this.disableTouch, { passive: false });
  }
}

export default OnLoadScrollToEl;